import {
  Box,
  VStack,
  HStack,
  //   Stack,
  Text,
  FormControl,
  FormHelperText,
  Breadcrumb,
  BreadcrumbItem,
  //   CircularProgress,
  // Badge,
  useDisclosure,
  //   CircularProgress,
  // useToast,
  // Checkbox,
  Container,
  Heading,
  // Divider,
  // IconButton,
  // Avatar,
} from "@chakra-ui/react";
import { useMemo, useState } from "react";
import { ChevronRightIcon } from "@chakra-ui/icons";

import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";

// import FCMB from "assets/png/fcmb.png";

import { useParams } from "react-router-dom";

import Select from "components/Select/Select";
// import Input from "components/Input/Input";
import { NumberInputWithMax } from "components/Input/NumberInput";
import Button from "components/Button/Button";
//   import { RSelect, OptionLabel } from "components/Select/RSelect";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";
import SubmitPin from "components/Modals/SubmitPin";

// import { useGetBanksDetailsQuery } from "services/bankApi";

// import useWallet from "hooks/useWalletBalance";
import useCoinInfo from "hooks/useCoinInfo";

// import useCopy from "hooks/useCopy";

import formatter from "util/formatter";
import useWalletBalance from "hooks/useWalletBalance";
import useBanks from "hooks/useBanks";
// import toPrecision from "util/toPrecision";

// import toCoinLocale from "util/toCoinLocale";
// import constants from "config/constant";

// const BankAccount = ({ state, setState }) => {
//   const { data: banks /*, isLoading */ } = useGetBanksDetailsQuery();

//   const history = useHistory();

//   // const banks = useMemo(() => data)
//   // console.log("banks", banks);

//   return (
//     <>
//       <FormControl>
//         <Select
//           placeholder="Select bank"
//           value={state?.bankId ?? ""}
//           onChange={(e) => setState({ bankId: e.target.value })}
//         >
//           {banks?.length ? (
//             banks?.map((item) => {
//               return (
//                 <option value={item._id} key={item._id}>
//                   {item.bankName} - {item.bankAccountNumber}
//                 </option>
//               );
//             })
//           ) : (
//             <option disabled>You haven't added a bank account. </option>
//           )}
//         </Select>

//         {banks?.length < 1 && (
//           <FormHelperText fontSize="xs">
//             <HStack>
//               <Text>You haven't added a bank account. Add it</Text>
//               <Button
//                 variant="unstyled"
//                 bg="transparent"
//                 minW="fit-content"
//                 w="fit-content"
//                 minH="fit-content"
//                 h="fit-content"
//                 fontSize="inherit"
//                 p="0"
//                 _focus={{ shadow: "none" }}
//                 _hover={{ shadow: "none" }}
//                 _active={{ shadow: "none" }}
//                 textTransform="lowercase"
//                 ml="4px !important"
//                 onClick={() => history.push("/dashboard/account/banks")}
//                 color="var(--primary)"
//               >
//                 here
//               </Button>
//             </HStack>
//           </FormHelperText>
//         )}
//       </FormControl>

// <FormControl fontSize="xs">
//   <strong>Note:</strong> The minimum amount you can withdraw is ₦500.00
// </FormControl>
//     </>
//   );
// };

const BankTransferAndMomo = ({ coin, minimum, txFee, state, setState }) => {
  const { banks } = useBanks();

  const filteredAccounts = useMemo(
    () =>
      (banks ?? []).filter((b) =>
        state?.method === "bank"
          ? b?.type !== "mobilemoney"
          : b?.type === "mobilemoney"
      ),
    [state?.method, banks]
  );

  const fee = useMemo(
    () => (state?.amount && +state?.amount * (1.55 / 100)) ?? 0,
    [state?.amount]
  );

  // console.log(filteredAccounts);
  // console.log("fee", fee);

  return (
    <>
      <FormControl mt="20px !important">
        <Select
          isRequired
          label="Select Account"
          // isInvalid={getBalance(state?.wallet) < 1}
          placeholder="Select Account"
          value={state?.bankId ?? ""}
          onChange={(e) => setState({ bankId: e.target.value })}
        >
          {filteredAccounts?.length ? (
            filteredAccounts?.map((item) => {
              return (
                <option value={item._id} key={item._id}>
                  {item.bankName} - {item.bankAccountNumber}
                </option>
              );
            })
          ) : (
            <option disabled>
              You haven't added a{" "}
              {state?.bankFilter === "gBank" ? "bank" : "momo"} account.
            </option>
          )}
        </Select>

        <FormHelperText fontSize="xs">
          Transaction Fee :{" "}
          <strong>{formatter(coin).format(coin === "ngn" ? 200 : fee)}</strong>
        </FormHelperText>

        <FormControl fontSize="xs" pt="20px">
          <HStack alignItems="flex-start">
            <strong>Note:</strong>
            <Box>
              <FormHelperText mt="0">
                The minimum amount you can withdraw is{" "}
                {formatter(coin).format(minimum)}
              </FormHelperText>
              <FormHelperText>
                Withdrawal request might take 6hrs or less to be processed
              </FormHelperText>
            </Box>
          </HStack>
        </FormControl>
      </FormControl>

      {banks?.length < 1 && (
        <FormHelperText fontSize="xs">
          <HStack>
            <Text>You haven't added a {state?.bankFilter} account. Add it</Text>
            <Button
              variant="unstyled"
              bg="transparent"
              minW="fit-content"
              w="fit-content"
              minH="fit-content"
              h="fit-content"
              fontSize="inherit"
              p="0"
              _focus={{ shadow: "none" }}
              _hover={{ shadow: "none" }}
              _active={{ shadow: "none" }}
              textTransform="lowercase"
              ml="4px !important"
              // onClick={() =>
              //   history.push(
              //     `/dashboard/account/${
              //       state?.bankFilter === "bank" ? "banks" : "mobilemoney/add"
              //     }`
              //   )
              // }
              color="var(--primary)"
            >
              here
            </Button>
          </HStack>
        </FormHelperText>
      )}
    </>
  );
};

const FundFiatWallet = (props) => {
  // const { userData } = props;
  const { coin } = useParams();

  const txFee = useMemo(() => {
    const map = {
      ghs: 100,
      ngn: 200,
    };

    return map[coin ?? "ngn"];
  }, [coin]);

  const minimumWithdraw = useMemo(() => {
    const map = {
      ghs: 100,
      ngn: 500,
    };

    return map[coin ?? "ngn"];
  }, [coin]);

  const currentPage = "Wallet";
  //   const { fiats, isLoading } = useWallet();

  const symbol = useMemo(() => {
    const map = {
      ngn: "₦",
      ghs: "GH₵",
      kes: "KES",
    };

    return map[coin ?? "ngn"];
  }, [coin]);

  // console.log(userData, symbol);

  const {
    isOpen: isSubmitPinOpen,
    onClose: onSubmitPinClose,
    onOpen: onSubmitPinOpen,
  } = useDisclosure();

  const [state, setState] = useState({});

  // const history = useHistory();

  const { label } = useCoinInfo(coin);
  const { getBalance /*isLoading: isLoadingBalance*/ } = useWalletBalance();

  // console.log("FIATS", fiats);
  const fundOptions = useMemo(() => {
    const map = {
      ngn: [
        { name: "Bank Account", value: "bank" },
        { name: "Mobile Money", value: "mobilemoney" },
      ],
      ghs: [
        // { name: "Bank Trasfer", value: "bank" },
        { name: "Mobile Money", value: "mobilemoney" },
      ],
      kes: [{ name: "Flutterwave", value: "flutterwave" }],
    };

    return map[coin ?? "ngn"];
  }, [coin]);

  const renderOption = () => {
    // const map = {
    //   ngn: {
    //     bank: <BankAccount state={state} setState={handleState} />,
    //     mobilemoney: (
    //       <BankTransferAndMomo
    //         coin={coin}
    //         txFee={txFee}
    //         state={state}
    //         setState={handleState}
    //       />
    //     ),
    //   },
    //   ghs: {
    //     bank: (
    //       <BankTransferAndMomo
    //         coin={coin}
    //         txFee={txFee}
    //         state={state}
    //         setState={handleState}
    //       />
    //     ),
    //     mobilemoney: (
    //       <BankTransferAndMomo
    //         coin={coin}
    //         txFee={txFee}
    //         state={state}
    //         setState={handleState}
    //       />
    //     ),
    //   },
    // };

    // return map[coin ?? "ngn"][state?.method ?? "bank_transfer"];

    return (
      <BankTransferAndMomo
        coin={coin}
        txFee={txFee}
        minimum={minimumWithdraw}
        state={state}
        setState={handleState}
      />
    );
  };

  const handleState = (newState) => {
    setState({ ...state, ...newState });
  };

  const balance = useMemo(() => getBalance(coin), [getBalance, coin]);

  const isLowerThanMinimum = useMemo(
    () => state?.amount && state?.amount < minimumWithdraw,
    [state?.amount, minimumWithdraw]
  );

  const isDisabled = useMemo(
    () =>
      !(state?.method && state?.amount && state?.bankId) || isLowerThanMinimum,
    [state, isLowerThanMinimum]
  );

  return (
    <Box>
      <Sidemenu currentPage={currentPage} logoutUser={props.logout} />
      <Header />

      <Box className="wallet">
        <Box
          className="page-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container maxW="container.xl">
            <Box w="100%">
              <Box px={["24px", "0", "0"]}>
                <Heading fontSize="3xl">Withdraw Wallet</Heading>
                <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
                  <BreadcrumbItem>
                    <BreadcrumbLink to="/dashboard/wallet?tab=fiat">
                      Wallet
                    </BreadcrumbLink>
                  </BreadcrumbItem>

                  <BreadcrumbItem>
                    <BreadcrumbLink to={`/dashboard/wallet/${coin}`}>
                      {label} Wallet
                    </BreadcrumbLink>
                  </BreadcrumbItem>

                  <BreadcrumbItem isCurrentPage>
                    <BreadcrumbLink isCurrentPage href="#">
                      Withdraw
                    </BreadcrumbLink>
                  </BreadcrumbItem>
                </Breadcrumb>
              </Box>

              <Box
                bg="white"
                border="1px solid #8688942f"
                w={["100%", "100%", "calc(100% - 25vw)"]}
                mt="32px"
                borderRadius="8px"
                p="48px 28px"
              >
                <VStack as="form" maxW="sm" m="0 auto">
                  <FormControl mt="20px !important">
                    <Select
                      isRequired
                      label="Withdraw Via"
                      // isInvalid={getBalance(state?.wallet) < 1}
                      placeholder="Select Method"
                      value={state?.method ?? ""}
                      onChange={(e) =>
                        handleState({
                          method: e.target.value,
                          bankFilter: e.target.value,
                        })
                      }
                    >
                      {fundOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.name}
                        </option>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl>
                    <Box as="label" d="inline-block" fontSize="sm" mb="6px">
                      Amount
                    </Box>
                    <NumberInputWithMax
                      isRequired
                      isInvalid={isLowerThanMinimum}
                      onMax={() =>
                        handleState({ amount: Number(balance).toFixed(2) })
                      }
                      type="number"
                      // label="Amount"
                      value={state?.amount ?? ""}
                      onChange={(e) => handleState({ amount: e })}
                      startAdornment={symbol}
                      //   endAdornment="USD"
                    />
                    {/* {coin === "ngn" && (
                      <FormHelperText fontSize="xs">
                        Transaction Fee :{" "}
                        <strong>{formatter(coin).format(txFee)}</strong>
                      </FormHelperText>
                    )} */}

                    {/* {coin === "ghs" && !isLoadingBalance && ( */}
                    <FormHelperText fontSize="xs">
                      Available Balance:{" "}
                      <Box as="strong" color="#03a438 !important">
                        {formatter(coin).format(balance)}
                      </Box>
                    </FormHelperText>
                    {/* )} */}
                  </FormControl>

                  {/* {state?.wallet && (
                    <FormControl>
                      <HStack fontSize="sm">
                        <Text>Available balance: </Text>
                        <Text
                          color={
                            !isInsufficientBalance
                              ? "var(--primary)"
                              : "red.400"
                          }
                        >
                          {toPrecision(
                            getBalance(state?.wallet),
                            state?.wallet
                          )}
                        </Text>
                      </HStack>
                    </FormControl>
                  )} */}

                  {state?.method && renderOption()}

                  {/* <FormControl>
                    <FormHelperText fontWeight="500">
                      
                    </FormHelperText>
                  </FormControl> */}

                  <Button
                    // isLoading={isFunding}
                    disabled={isDisabled}
                    w="100%"
                    minH="64px"
                    mt="72px !important"
                    // type="submit"
                    onClick={onSubmitPinOpen}
                  >
                    Submit
                  </Button>
                </VStack>
              </Box>
            </Box>

            <SubmitPin
              data={{
                currency: coin ?? "ngn",
                amount: state?.amount,
                bankId: state?.bankId,
                reason: state?.reason ?? "",
                fiatPaymentMethod: state?.method,
                callbackSuccessUrl: `${process.env.REACT_APP_DOMAIN}/dashboard/homechangeradeposit/withdrawSuccess`,
                callbackFailedUrl: `${process.env.REACT_APP_DOMAIN}/dashboard/homechangeradeposit/withdrawFailed`,
              }}
              isOpen={isSubmitPinOpen}
              onClose={onSubmitPinClose}
              clearData={() => setState(null)}
            />
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default FundFiatWallet;
